import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Input } from "~/components/input";
import { RadioButtonGroup } from "~/components/radio-button-group";
import { RadioButtonGroupItem } from "~/components/radio-button-group/item";
import type { Record } from "~/tools/record";

import type { ModeFormState, StepValueFormState } from "./form-state";
import { ALL_MODES, DEFAULT_STEP, type Mode } from "./settings";

export interface WidgetThresholdsStepValueProps {
	value: StepValueFormState;
	name: string;
	onBlur?: VoidFunction;
}

export const WidgetThresholdsStepValue: React.FC<WidgetThresholdsStepValueProps> = ({ value, name, onBlur }) => {
	const monitor = useMonitor();

	return (
		<Input
			name={name}
			onBlur={onBlur}
			onChange={(event) => {
				value.setInput(event.target.value);
			}}
			placeholder={DEFAULT_STEP.value.toString()}
			type="number"
			value={value.getInput(monitor)}
		/>
	);
};

const THRESHOLD_MODES_TO_LABEL = {
	absolute: "Absolute",
	percent: "Percent",
} satisfies Record<Mode>;

export interface WidgetThresholdsModeProps {
	className?: string;
	disabled?: boolean;
	name: string;
	mode: ModeFormState;
}

export const WidgetThresholdsMode: React.FC<WidgetThresholdsModeProps> = ({ className, disabled, mode, name }) => {
	const monitor = useMonitor();

	return (
		<RadioButtonGroup
			className={className}
			onValueChange={(value) => mode.setInput(value)}
			value={mode.getInput(monitor)}
		>
			{ALL_MODES.map((thresholdMode) => (
				<RadioButtonGroupItem disabled={disabled} key={thresholdMode} name={name} value={thresholdMode}>
					{THRESHOLD_MODES_TO_LABEL[thresholdMode]}
				</RadioButtonGroupItem>
			))}
		</RadioButtonGroup>
	);
};
